<template>
  <div class="creatTrip_Box">
    <el-dialog title="创建行程"  width="65%" style="margin: 0 auto;width: 700px;" :visible.sync="createtripAlertState"
      :close-on-click-modal='false' :close-on-press-escape='false' @close="closeCreateTrip" :destroy-on-close="true" :append-to-body="true">
      <el-radio-group v-if="showCreatePlanType" v-model="planCreateType" style="margin-top: 10px;">
        <el-radio :label="0">创建行程</el-radio>
        <el-radio :label="1">文档导入识别</el-radio>
        <el-radio :label="2">AI创建</el-radio>
      </el-radio-group>
      <div v-if="planCreateType==0 || planCreateType==2" class="createManually">
        <p>
          <span>出发日期：</span>
          <el-date-picker v-model="creatTripDate" @change="changeTripDate()" value-format="yyyy-MM-dd" type="date" style="width:200px;" size="small" placeholder="选择日期"></el-date-picker>
        </p>
        <p v-show="showEndTripDate">
          <span>结束日期：</span>
          <el-date-picker v-model="endTripDate"  value-format="yyyy-MM-dd" type="date" style="width:200px;" size="small"
            placeholder="选择日期" :picker-options="pickerOptions" @change="changeDate()" :default-value="creatTripDate"></el-date-picker>
        </p>
        <p v-show="showPlanDay">
          <span>出行天数：</span>
          <el-select v-model="creatTripDays" placeholder="请选择" style="width:200px;" size="small" @change="changeDate()">
            <el-option v-for="item in 99" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </p>
        <p>
          <span>预估人数：</span>
          <el-input maxlength="5" onkeyup="value=value.replace(/[^\d]/g,'')" style="width:200px;" size="small" v-model="useNumber" placeholder="请输入预估人数"></el-input>
        </p>
        <div v-if="planCreateType==2">
          <p><span>您的出发地点：</span><el-input size="small" v-model="startCity" style="width:200px;" /></p>
          <p><span>您的返回地点：</span><el-input size="small" v-model="endCity" style="width:200px;" /></p>
          <p><span>您的首站旅游目的地：</span><el-input size="small" v-model="toFirstCity" style="width:200px;" /></p>
          <p><span>您的尾站旅游目的地：</span><el-input size="small" v-model="toLastCity" style="width:200px;" /></p>
          <p><span>您行程中想经过的国家和城市：</span><el-input size="small" v-model="routeCity" style="width:200px;" /></p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="createtripAlertState = false">取 消</el-button>
          <el-button type="primary" @click="createTrip">{{planCreateType==2?'请给我答案':'确 定'}}</el-button>
        </span>
      </div>

      <div v-if="planCreateType==1" class="customManually">
        <p style="margin-top: 20px;">
          <span>预估人数：</span>
          <el-input maxlength="5" onkeyup="value=value.replace(/[^\d]/g,'')" style="width:200px;" size="small" v-model="useNumber" placeholder="请输入预估人数"></el-input>
        </p>

        <el-upload
          class="upload-demo"
          style="margin-top: 20px;"
          ref="upload"
          action="#"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-change="changeFile"
          :file-list="fileList"
          :auto-upload="false">
          <el-button slot="trigger" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          <div slot="tip" class="el-upload__tip">只能上传doc/docx文件，且不超过30M</div>
        </el-upload>

        <span slot="footer" class="dialog-footer">
          <el-button @click="createtripAlertState = false">取 消</el-button>
          <el-button type="primary" @click="customCreateTrip">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <DialogMobileChat @successfullyGenerated="createtripAlertState = false" ref="mobileChat"></DialogMobileChat>
  </div>
</template>
<script>
import PlanApi from '@/components/Api/PlanApi.js'
import { getPlanInfo, getOrderPlanInfo} from '../../js/function'
import DialogMobileChat from '../../../../components/ChatGPT3.0/DialogMobileChat.vue'

export default {
  data(){
    return{
      startCity:null,
      endCity:null,
      toFirstCity:null,
      toLastCity:null,
      routeCity:null,
      createtripAlertState : false,
      creatTripDate:null,
      creatTripDays:null,
      inquiryId:null,
      useNumber:null,
      planCreateType: 0,
      fileList: [],
      fileObj: "",
      isUser:null,
      showCreatePlanType:true,
      showPlanDay:true,
      showEndTripDate:true,
      endTripDate:null,
      pickerOptions: {
        disabledDate:time=>{
          return this.checkTime(time)
        }
      },
      oldPlanObj:{},
    }
  },
  components: {
    DialogMobileChat
  },
  methods:{
    checkTime(time){
      return time.getTime() < this.dateAddDay(this.creatTripDate,-1).getTime()
    },
    customCreateTrip() {
      let loading = this.$loading({
        lock: true,
        text: "识别中,请稍后...",
        spinner: 'el-icon-phone-outline',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      new PlanApi("plan").wordDistinguish(this.fileList[0],this.useNumber).then(res => {
        if (res.status == 200) {
          this.$message.success("识别成功")
          this.$store.commit('setPlanId',res.data.planId)
          getPlanInfo(res.data.planId,res.data.budgetMainId)
        } else {
          this.$message.error(res.statusText)
        }
        loading.close()
      }).catch(() => {
        this.$message.error("系统异常")
        loading.close()
      })
    },
    changeTripDate(){
      if(!this.oldPlanObj.id){
        this.creatTripDays=null
        this.endTripDate=null
      }
    },
    changeDate(){
      if(this.creatTripDate&&this.endTripDate){
        this.creatTripDays = this.getBetweenDay([this.creatTripDate,this.endTripDate])+1
      }
      if(this.creatTripDate&&this.creatTripDays){
        this.endTripDate = this.dateAddDay(this.creatTripDate,(this.creatTripDays-1))
      }
    },
    changeFile(e) {
      if (e.name.indexOf(".doc") === -1 && e.name.indexOf(".docx") === -1 && e.name.indexOf(".xls") === -1 && e.name.indexOf(".xlsx") === -1) {
        this.$message.info(`sorry,不支持的文件格式！`)
        this.fileList = []
      } else {
        this.fileList = [e]
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforOpen(inquiryId){
      this.createtripAlertState = true;
      this.inquiryId = inquiryId;
    },
    closeCreateTrip(){
      this.creatTripDate = '';
      this.endTripDate=''
      this.creatTripDays = '';
      this.useNumber=''
      this.createtripAlertState = false;
    },
      formatDate(dateString) {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
      },
    createTrip() {
      if(!this.creatTripDate){
        this.$message({
          type: "warning",
          message: "请选择行程出发日期",
          duration: 1000
        })
        return;
      }
      if(!this.creatTripDays){
        this.$message({
          type: "warning",
          message: "请选择行程出行天数",
          duration: 1000
        })
        return;
      }
      if(!this.useNumber){
        this.$message({
          type: "warning",
          message: "请选择行程预估人数",
          duration: 1000
        })
        return;
      }
      if (this.planCreateType == 2) {
        var test='我的出发时间是'+this.creatTripDate+'到'+this.endTripDate
        if(this.startCity&&this.startCity!=''){
          test+="我的出发地点是"+this.startCity
        }
        if(this.endCity&&this.endCity!=''){
          test+="我的返回地点是"+this.endCity
        }
        if(this.toFirstCity&&this.toFirstCity!=''){
          test+="我的首站旅游目的地是"+this.toFirstCity
        }
        if(this.toLastCity&&this.toLastCity!=''){
          test+="我的尾站旅游目的地是"+this.toLastCity
        }
        if(this.routeCity&&this.routeCity!=''){
          test+="我行程中想经过的国家和城市是"+this.routeCity
        }
        test+='请结合上面的信息，制作行程，注意考虑到城市地点之间的距离的合理性（距离需要最短），时间的合理性，并请在每日的安排里加入推荐景点 ，景点选择当地最有名气的，请写明景点名称开门时间和简单介绍 '
        let programmeInfo = {
            startDate:this.creatTripDate,
            endDate:this.formatDate(this.endTripDate),
            number:this.useNumber,
            startCity:this.startCity,
            endCity:this.endCity,
            toFirstCity:this.toFirstCity,
            toLastCity:this.toLastCity,
            routeCity:this.routeCity,
        }
        this.$refs.mobileChat.init(programmeInfo)
      } else {
        var obj = {
          departureDate: this.creatTripDate,
          planDay: this.creatTripDays,
          useNumber:this.useNumber,
          oldId:this.oldPlanObj.id,
          oldPlanId:this.oldPlanObj.planId,
          informationId:this.inquiryId
        }
        new PlanApi('plan').createTrip(obj).then(res => {
          if (res.status == 200) {
            this.closeCreateTrip()
            this.$message({ type: "success",message: "保存成功"});
            this.isUser = null
            this.$store.commit('setPlanId', res.data.planId)
            if (this.planCreateType == 0) {
              this.$confirm('是否进入地图模式?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push({name: "mapPlan",query: {type: 1}});
              }).catch(() => {
              });
            }
            if(this.$route.path=='/newNavBar/plan'){
              getPlanInfo(this.$store.state.planId,null)
              getOrderPlanInfo(this.$store.state.planId,null)
            }else{
              this.$router.push({name: "plan"});
            }
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.createManually {
  p{
    margin:10px 0;
  }
  margin-top: 5px;
}
>>>.creatTrip_Box .el-dialog{
  width:400px;
}
</style>
